module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.9.4-271.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.9.4.md
// module id = 716
// module chunks = 222